import Icon from "@components/Icon";
import {
	desktopLMediaQuery,
	desktopMediaQuery,
	device,
	isEmptyContentfulEntry,
	laptopMediaQuery,
	tabletMediaQuery,
} from "@helpers";
import type { IPageModuleTextListFields } from "@types-contentful";
import React from "react";
import styled from "styled-components";

import { colours } from "@helpers/colours";

const Container = styled.div`
  margin-bottom: 0px !important;

  flex-direction: column;
  padding: 40px 35px;
  @media (min-width: 834px) {
    flex-direction: row;
    padding: 40px 10%;
  }
  display: flex;
  justify-content: space-between;
  & h2 {
  }
  & p {
  }
  & span {
  }
`;

const StyledHeadline = styled.h2`
  padding-bottom: 27px;
  width: 100% !important;

  @media (min-width: ${device.laptop}) {
    width: 50% !important;
  }
`;

const StyleMobilePlanTextIconsWrapper = styled.div`
  @media (min-width: ${device.laptop}) {
    margin-left: 5%;
  }
`;

const StyledMobileIconText = styled.p`
  color: ${colours.MIDNIGHT_BLUE};
  margin-left: 25px;
`;

const Row = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 12px;
  object-fit: contain;
`;

const VideoContainer = styled.div`
  display: block;
  height: 230px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  width: 100%;

  ${tabletMediaQuery} {
    height: 490px;
  }

  ${laptopMediaQuery} {
    height: 400px;
    width: 50% !important;
  }

  ${desktopMediaQuery} {
    height: 600px;
    width: 50% !important;
  }

  ${desktopLMediaQuery} {
    height: 500px;
    width: 50% !important;
  }

  iframe {
    height: 100%;
    left: 0;
    position: relative;
    top: 0;
    width: 100%;
  }
`;

const iconSizes = {
	iconMobile: 30,
	iconTablet: 30,
	iconLaptop: 30,
	iconDesktop: 40,
	iconDesktopLarge: 40,
};

const TextListModule = ({
	headline,
	iconList,
	videoTitle,
	youtubeVideoId,
}: IPageModuleTextListFields) => {
	const listOfIcons = iconList?.list;

	const url = `https://www.youtube.com/embed/${youtubeVideoId}?origin=https://felixmobile.com.au&rel=0&controls=0&modestbranding=1&color=white&fs=0&autohide=1&showinfo=0&autoplay=0&enablejsap=1`;

	return (
		<>
			<Container>
				{!isEmptyContentfulEntry(headline) && (
					<StyledHeadline>{headline}</StyledHeadline>
				)}
				{!isEmptyContentfulEntry(youtubeVideoId) && (
					<>
						<VideoContainer>
							<iframe
								src={url}
								title={videoTitle}
								allow="accelerometer; autoplay; encrypted-media; gyroscope;"
								frameBorder="0"
								allowFullScreen={true}
							/>
						</VideoContainer>
					</>
				)}
				{isEmptyContentfulEntry(youtubeVideoId) && (
					<StyleMobilePlanTextIconsWrapper>
						<div>
							{listOfIcons &&
								listOfIcons.map((icon: { text: string; iconRef: string }) => (
									<Row key={icon.text}>
										<Icon
											iconName={
												icon.iconRef === "sim-esim-felix"
													? "sim-esim"
													: icon.iconRef
											}
											iconSizes={iconSizes}
											alt={icon.text}
										/>
										<StyledMobileIconText>{icon.text}</StyledMobileIconText>
									</Row>
								))}
						</div>
					</StyleMobilePlanTextIconsWrapper>
				)}
			</Container>
		</>
	);
};

export default TextListModule;
